var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogobitrix24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 53,
    viewBox: "0 0 273 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.689 51.822h9.422V17.667H37.69v34.155zM36.51 8.766c0-2.884 2.276-5.233 5.333-5.233 2.991 0 5.267 2.215 5.267 5.233 0 2.953-2.276 5.367-5.267 5.367-3.057 0-5.333-2.347-5.333-5.367zM55.446 43.844V26.978h-5.98v-7.23h5.98v-7.641l9.347-2.685V19.75h9.829l-2.13 7.229h-7.699v14.525c0 3.03.962 4.062 3.093 4.062 1.787 0 3.574-.62 4.811-1.446l2.68 6.334C72.973 52.105 68.712 53 65.482 53c-6.186 0-10.035-3.442-10.035-9.156M77.733 18.512h8.545l1.124 3.521c2.998-2.606 5.846-4.366 9.668-4.366 1.724 0 3.823.493 5.397 1.55l-3.523 7.887c-1.798-1.057-3.523-1.268-4.497-1.268-2.174 0-3.897.704-6.595 2.747v23.24H77.733V18.511zM103.644 51.822h9.423V17.667h-9.423v34.155zm0-43.056c0-2.884 2.277-5.233 5.333-5.233 2.991 0 5.267 2.215 5.267 5.233 0 2.953-2.276 5.367-5.267 5.367-3.056 0-5.333-2.347-5.333-5.367zM128.026 34.636l-12.25-16.97h9.914l7.505 10.4 7.506-10.4h9.913l-12.392 16.97 12.534 17.186h-9.913l-7.719-10.687-7.789 10.687h-9.913l12.604-17.186z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.196 14.94c0-4.436-3.698-5.992-7.632-5.992-5.272 0-9.6 1.712-13.612 3.502l-2.755-8.17C161.683 2.256 167.899 0 175.295 0c11.566 0 17.152 5.758 17.152 13.85 0 14.162-19.67 18.13-22.975 28.946h23.684v9.026h-37.689c2.124-25.288 25.729-26.767 25.729-36.882",
    fill: "#0065A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.138 31.567h4.743v-5.518c0-3.964.316-8.55.475-9.56L202.578 31.8c.948-.078 4.743-.233 6.56-.233zm-18.338 2.39l25.862-32.78h7.68v30.985h7.68v8.585h-7.68V53h-10.423V40.747H190.8v-6.79zM254.989 31.8c-7.481 0-13.545-6.328-13.545-14.133 0-7.806 6.064-14.134 13.545-14.134 7.48 0 13.544 6.328 13.544 14.134 0 7.805-6.064 14.133-13.544 14.133m0-31.8c-9.432 0-17.078 7.91-17.078 17.666 0 9.758 7.646 17.667 17.078 17.667 9.432 0 17.078-7.91 17.078-17.667C272.067 7.91 264.421 0 254.989 0",
    fill: "#0065A3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.4 17.667h2.356V10.6H254.4v7.067z",
    fill: "#0065A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M254.4 17.667h7.067V15.31H254.4v2.356z",
    fill: "#0065A3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.08 45.933c4.865 0 7.298-2.03 7.298-6.712 0-3.98-2.433-6.243-6.465-6.243H10.6v12.955h4.48zm-1.482-21.2c3.46 0 5.246-2.295 5.246-5.198 0-3.039-1.729-5.402-5.42-5.402H10.6v10.6h2.998zM0 5.89h14.341c9.907 0 14.341 5.933 14.341 11.939 0 3.86-1.87 7.649-5.404 9.508v.143c5.474 1.5 8.522 6.076 8.522 11.366C31.8 45.995 26.396 53 15.588 53H0V5.889z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogobitrix24);
export default __webpack_public_path__ + "static/media/logobitrix24.f239bcbd0317a05ffd1e47f23ca51113.svg";
export { ForwardRef as ReactComponent };